import React from 'react';
import { connect } from 'react-redux';

const MessageNotify = ({ unreadContacts, children }) =>
    (unreadContacts > 0 ?
        <p className="chat-notify">
            {children}
        </p> :
        <>
            {children}
        </>);

const mapStateToProps = state => ({
    unreadContacts: state.chat.profile.unreadContacts
});

export default connect(mapStateToProps)(MessageNotify);
